import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Router} from '@angular/router';
import {MeetingService} from '../../services/meeting.service';
import {CookieService} from 'angular2-cookie/services/cookies.service';
import {LocalStorageService} from 'angular-2-local-storage';
import * as moment from 'moment';
import {ToasterService} from 'angular2-toaster';

declare var document: any;
declare var $: any;

interface TimeDisplay {
  value: string;
  display: string;
}

@Component({
  selector: 'app-city', templateUrl: './city.component.html', styleUrls: ['./city.component.css']
})
export class CityComponent implements OnInit {

  busy: Promise<any>;
  id: any;
  building_address: any;
  building_id: any;
  opentime: any;
  closetime: any;
  currentDate: any;
  e_name: any;
  skipdate: any;
  neutral_event: any = [];
  rooms: any = [];
  city: any = [];
  select_building: any;
  select_city: any;
  buildings: any = [];
  authcode;
  select_room;
  today = new Date();

  openTimeIntervalArray: TimeDisplay[] = [];

  constructor(public route: ActivatedRoute, public router: Router, public meetingService: MeetingService, private _cookieService: CookieService, private toasterService: ToasterService, private storage: LocalStorageService) {

    const val = this.storage.get('user');
    if (val) {
      this.authcode = val[0].authcode;

    }

    this.select_room = this.storage.get('select_room');

    // $("#calendar").css("display","");
    const set = this;
    $(document).ready(function () {

      $('#calendar').fullCalendar({
        schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
        droppable: true,
        selectable: true,
        header: {
          left: 'title', // center: '',
          right: 'agendaWeek,agendaDay prev,next'
        },
        fixedWeekCount: false,
        defaultDate: new Date(),
        editable: true,
        defaultView: 'agendaDay',
        views: {
          Buildingweek: {
            type: 'agendaWeek', groupByDateAndResource: true,
          }, agendaDay: {
            groupByDateAndResource: false,
          }, Buildingday: {
            type: 'agendaDay', groupByDateAndResource: true,
          }
        },
        viewRender: function (view, element) {
          if (set.rooms) {
            for (let i = 0; i < set.rooms.length; i++) {
              $('th[data-resource-id=' + set.rooms[i].id + ']')
                .html('<b>' + set.rooms[i].caldesc + '</b><p style=\'font-weight:100\'>' + set.rooms[i].line2 + '</p>');
            }
          }
          if (view.name === 'agendaWeek' || view.name === 'Buildingweek') {
            $('#calendar').fullCalendar('changeView', 'Buildingweek');
          } else if (view.name === 'agendaDay' || view.name === 'Buildingday') {
            $('#calendar').fullCalendar('changeView', 'Buildingday');
          }

        },
        weekends: false,
        hiddenDays: [6, 7],
        minTime: '08:30:00',
        maxTime: '18:30:00',
        height: 'auto',
        resources: [],
        eventLimit: true,
        events: [],
        timezone: 'local',
        allDaySlot: false,
        longPressDelay: true,
        select: function (start, end, jsEvent, view, resource) {

          if (resource) {
            // // console.log(resource.temp_name);
            $('#select_room b').empty();
            $('#select_room b').append('Room: ' + resource.temp_name);
            const resourceId = resource.id;
            $('#rumid').val(resourceId);
          }
          // // console.log(end);
          $('#click_date').val(start._d);
          (<any>$('#myModal33')).modal('show');
          let d = start._i[3].toString();
          let c = start._i[4].toString();
          let d1 = end._i[3].toString();
          let c1 = end._i[4].toString();
          if (d.length === 1) {
            d = '0' + d;
          }
          if (c.length === 1) {
            c = '0' + c;
          }
          if (d1.length === 1) {
            d1 = '0' + d1;
          }
          if (c1.length === 1) {
            c1 = '0' + c1;
          }
          const time = d + ':' + c;
          const time1 = d1 + ':' + c1;

          $('#curdate').empty();
          $('#curdate').append(moment(new Date(start._d)).format('DD-MMM-YYYY'));
          // $('#curdate').append(datePipe.transform(new Date(start._d), 'dd-MMM-yyyy'));
          $('.f_time').val(time);
          $('.t_time').val(time1);
          $('#delbtn').hide();
          $('#addbtn').show();
          $('#updatebtn').hide();
          $('#buyxxhour').hide();
          $('#buy5hour').hide();
          $('#buy15hour').hide();
          $('.not_enough_hour').empty();
        },


        dayClick: function (date, jsEvent, view) {
          // // console.log(date);

          let d = date._i[3].toString();
          let c = date._i[4].toString();

          if (d.length === 1) {
            d = '0' + d;
          }
          if (c.length === 1) {
            c = '0' + c;
          }
          const time = d + ':' + c;
          $('#e_name').val('');
          $('.f_time').val(time);
          $('.t_time').val('');
          // $('#f_time').val(time);
          // $('#t_time').val('');
          (<any>$('#myModal33')).modal('show');
          $('#curdate').empty();

          $('#curdate').append(moment(new Date(date._d)).format('DD-MMM-YYYY'));
          // $('#curdate').append(datePipe.transform(new Date(date._d), 'dd-MMM-yyyy'));
          $('#click_date').val(date._d);
          $('#delbtn').hide();
          $('#updatebtn').hide();
          $('#addbtn').show();
          $('#buyxxhour').hide();
          $('#buy5hour').hide();
          $('#buy15hour').hide();
          $('.not_enough_hour').empty();
        }
      });
      // alert("hii");
      $('.fc-agendaWeek-button').html('week view');
      $('.fc-agendaDay-button').html('day view');

    });

    const self = this;
    $(function () {
      $('body').on('click', 'button.fc-prev-button', function () {
        self.fetchBuildingMeeting();
      });

      $('body').on('click', 'button.fc-next-button', function () {
        self.fetchBuildingMeeting();
      });

      $('body').on('click', 'button.fc-agendaWeek-button', function () {
        self.fetchBuildingMeeting();
      });
    });

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      // console.log(params);
      this.id = params['c_id'];
      //  this.getBuildingAddress(this.id);
      this.getCity();
    });
  }

  getCity() {
    this.busy = this.meetingService.getCity('').subscribe(response => {
      if (response) {
        this.city = response;
        // console.log(this.city);
        for (let n = 0; n < this.city.length; n++) {
          if (this.city[n].id === this.id) {
            this.select_city = this.city[n].cityname;
          }
        }
        // this.getavailHours();
        this.getBuildingAddress(this.id);

      } else {
        // console.log("error");
      }
    });
  }

  fetchBuildingMeeting() {
    // console.log("in building");
    $('#calendar').fullCalendar('removeEvents');
    this.getBuildingsMeetingbyside(this.building_id, '');
  }

  getBuildingAddress(b_id) {
    this.meetingService.getBuildingAddress(b_id).subscribe(response => {
      if (response) {
        // console.log(response);
        this.buildings = response;
        this.building_address = response[0].address;
        this.building_id = response[0].id;
        this.opentime = response[0].opentime;
        this.closetime = response[0].closetime;
        this.select_building = response[0].address;
        this.getBuildingsMeeting(this.building_id, '');
      } else {
        // console.log("error");
      }
    });
  }

  getBuildingsMeeting(b_id, authcode) {
    // this.storage.set('select_building_id',b_id);
    console.log(this.authcode + ' -------------------');
    const cont = this;
    setTimeout(function () {
      cont.currentDate = $('#calendar').fullCalendar('getDate');
      const view = $('#calendar').fullCalendar('getView');
      // // console.log(view.name);
      const dt = new Date(cont.currentDate._d);
      // // console.log(dt);
      let stdt;
      let ldt;

      const dayname = moment(dt).format('ddd'); // cont.datePipe.transform(dt, 'EE');
      if (view.name === 'agendaWeek' || view.name === 'Buildingweek') {
        if (dayname === 'Mon') {
          const chk = dt.setDate(dt.getDate());
          const st = new Date(chk);
          stdt = moment(st).format('YYYY-MM-DD'); // cont.datePipe.transform(st, 'yyyy-MM-dd');
          // console.log(stdt);
          ldt = dt.setDate(dt.getDate() + 4);
        } else if (dayname === 'Tue') {
          const chk = dt.setDate(dt.getDate() - 1);
          const st = new Date(chk);
          stdt = moment(st).format('YYYY-MM-DD'); // cont.datePipe.transform(st, 'yyyy-MM-dd');
          // console.log(stdt);
          ldt = dt.setDate(dt.getDate() + 4);
        } else if (dayname === 'Wed') {
          const chk = dt.setDate(dt.getDate() - 2);
          const st = new Date(chk);
          stdt = moment(st).format('YYYY-MM-DD'); // cont.datePipe.transform(st, 'yyyy-MM-dd');
          // console.log(stdt);
          ldt = dt.setDate(dt.getDate() + 4);
        } else if (dayname === 'Thu') {
          const chk = dt.setDate(dt.getDate() - 3);
          const st = new Date(chk);
          stdt = moment(st).format('YYYY-MM-DD'); // cont.datePipe.transform(st, 'yyyy-MM-dd');
          // console.log(stdt);
          ldt = dt.setDate(dt.getDate() + 4);
        } else if (dayname === 'Fri') {
          const chk = dt.setDate(dt.getDate() - 4);
          const st = new Date(chk);
          stdt = moment(st).format('YYYY-MM-DD'); // cont.datePipe.transform(st, 'yyyy-MM-dd');
          // console.log(stdt);
          ldt = dt.setDate(dt.getDate() + 4);
        } else if (dayname === 'Sat') {
          const chk = dt.setDate(dt.getDate() - 5);
          const st = new Date(chk);
          stdt = moment(st).format('YYYY-MM-DD'); // cont.datePipe.transform(st, 'yyyy-MM-dd');
          // console.log(stdt);
          ldt = dt.setDate(dt.getDate() + 4);
        } else if (dayname === 'Sun') {
          // console.log("hiii");
          const chk = dt.setDate(dt.getDate() + 1);
          const st = new Date(chk);
          stdt = moment(st).format('YYYY-MM-DD'); // cont.datePipe.transform(st, 'yyyy-MM-dd');
          // console.log(stdt);
          ldt = dt.setDate(dt.getDate() + 5);
        }

      } else {
        stdt = moment(dt).format('YYYY-MM-DD'); // cont.datePipe.transform(dt, 'yyyy-MM-dd');
        ldt = dt.setDate(dt.getDate() + 1);
      }
      const ldtd = new Date(ldt);
      const ltdt = moment(ldtd).format('YYYY-MM-DD'); // cont.datePipe.transform(ldtd, 'yyyy-MM-dd');

      cont.busy = cont.meetingService.getBuildingsMeeting(b_id, authcode, stdt, ltdt).subscribe(response => {
        if (response) {
          // console.log(response);
          const resources = $('#calendar').fullCalendar('getResources');
          // // console.log(resources);
          for (let i = 0; i < resources.length; i++) {
            $('#calendar').fullCalendar('removeResource', {
              id: resources[i].id
            });
          }
          $('#calendar').fullCalendar('refetchEvents');
          $('#calendar').fullCalendar('removeEvents');

          cont.busy = cont.meetingService.getRooms(b_id, authcode).subscribe(res => {
            if (res) {
              cont.rooms = res;
              for (let i = 0; i < res.length; i++) {
                $('#calendar').fullCalendar('addResource', {
                  id: res[i].id, title: res[i].caldesc, temp_name: res[i].roomname
                });

              }
              for (let i = 0; i < res.length; i++) {
                $('th[data-resource-id=' + res[i].id + ']')
                  .html('<b>' + res[i].caldesc + '</b><p style=\'font-weight:100\'>' + res[i].line2 + '</p>');
              }
            }
          });
          if (view.name === 'agendaWeek' || view.name === 'Buildingweek') {
            $('#calendar').fullCalendar('changeView', 'Buildingweek');
          } else {
            $('#calendar').fullCalendar('changeView', 'Buildingday');
          }

          for (let i = 0; i < response.length; i++) {
            // if(response[i].userid == this.user[0].userid){

            let editable;
            let color;

           // if (response[i].editable === 0) {
              editable = false;
              color = '#3a87ad';
           /* } else {
              editable = false;
              color = '#3a87ad';
            }
*/
            const event = {
              id: response[i].meetingid,
              resourceId: response[i].roomid,
              title: response[i].description,
              start: response[i].start,
              end: response[i].end,
              editable: editable,
              color: color,
              avail_hours: ''
            };
            $('#calendar').fullCalendar('renderEvent', event, true);
            // this.getavailHours();
            // }
          }
        } else {
          // console.log("error");
        }
      });
    }, 500);

    // var stdt = this.datePipe.transform(dt, 'yyyy-MM-dd');

  }

  getBuildingsMeetingbyside(b_id, authcode) {
    // this.building_id = b_id;
    $('#calendar').fullCalendar('removeEvents');
    this.currentDate = $('#calendar').fullCalendar('getDate');
    const view = $('#calendar').fullCalendar('getView');
    // // console.log(this.currentDate);
    const dt = new Date(this.currentDate._d);
    const dayname = moment(dt).format('ddd'); // this.datePipe.transform(dt, 'EE');
    // // console.log(dt);
    // var stdt = this.datePipe.transform(dt, 'yyyy-MM-dd');
    let stdt;
    let ldt;

    if (view.name === 'agendaWeek' || view.name === 'Buildingweek') {
      if (dayname === 'Mon') {
        const chk = dt.setDate(dt.getDate());
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Tue') {
        const chk = dt.setDate(dt.getDate() - 1);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Wed') {
        const chk = dt.setDate(dt.getDate() - 2);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Thu') {
        const chk = dt.setDate(dt.getDate() - 3);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Fri') {
        const chk = dt.setDate(dt.getDate() - 4);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Sat') {
        const chk = dt.setDate(dt.getDate() - 5);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 4);
      } else if (dayname === 'Sun') {
        // console.log("hiii");
        const chk = dt.setDate(dt.getDate() + 1);
        const st = new Date(chk);
        stdt = moment(st).format('YYYY-MM-DD'); // this.datePipe.transform(st, 'yyyy-MM-dd');
        // console.log(stdt);
        ldt = dt.setDate(dt.getDate() + 5);
      }

    } else {
      stdt = moment(dt).format('YYYY-MM-DD'); // this.datePipe.transform(dt, 'yyyy-MM-dd');
      ldt = dt.setDate(dt.getDate() + 1);
    }
    const ldtd = new Date(ldt);
    const ltdt = moment(ldtd).format('YYYY-MM-DD'); // this.datePipe.transform(ldtd, 'yyyy-MM-dd');

    // this.subscription.add(
    this.meetingService.getBuildingsMeeting(b_id, authcode, stdt, ltdt).subscribe(response => {
      if (response) {
        // // console.log(response);
        for (let i = 0; i < this.rooms.length; i++) {
          $('th[data-resource-id=' + this.rooms[i].id + ']')
            .html('<b>' + this.rooms[i].caldesc + '</b><p style=\'font-weight:100\'>' + this.rooms[i].line2 + '</p>');
        }
        $('#calendar').fullCalendar('removeEvents');
        for (let i = 0; i < response.length; i++) {
          // if(response[i].userid == this.user[0].userid){

          let editable;
          let color;

        //  if (response[i].editable === 0) {
          /*  editable = false;
            color = '#3a87ad';
          } else {
          */  editable = false;
            color = '#3a87ad';
          //}
          const event = {
            id: response[i].meetingid,
            resourceId: response[i].roomid,
            title: response[i].description,
            start: response[i].start,
            end: response[i].end,
            editable: editable,
            color: color,
            avail_hours: ''
          };
          $('#calendar').fullCalendar('renderEvent', event, true);
          // }
        }
      }
    });
  }

  eventAdd() {
    // // console.log("hello");
    const room_id = document.getElementById('rumid').value;
    const f_time = document.getElementById('f_time').value;
    const t_time = document.getElementById('t_time').value;
    const click_date = document.getElementById('click_date').value;
    const room_name = $('#select_room b').text();

    const e_name = this.e_name;
    // console.log(room_id +', '+f_time+', '+t_time+', '+e_name+', '+click_date+', '+room_name );
    this.neutral_event = [{
      'r_id': room_id,
      'f_time': f_time,
      't_time': t_time,
      'e_name': e_name,
      'click_date': click_date,
      'room_name': room_name,
      'city_id': this.id,
      'building_id': this.building_id,
      'address': this.building_address
    }];
    // // console.log(this.neutral_event);
    this.storage.set('neutral_event', this.neutral_event);
    setTimeout(function () {
      (<any>$('#myModal')).modal('show');
    }, 500);
  }

  getBuildings(cid, c_name) {

    console.log('Getting buildings...', cid);
    // pr's code
    // this.city_id = cid;
    if (cid === this.storage.get('select_city_id') && this.storage.get('select_building')) {
      console.log('What is stored...');
    } else {
      this.select_city = c_name;
      this.storage.set('select_city', this.select_city);
      this.storage.set('select_city_id', cid);
      this.storage.remove('select_building');
      this.storage.remove('select_building_id');
      this.storage.remove('select_room');
      this.storage.remove('select_room_id');
      this.select_building = null;
      this.select_room = null;
      this.buildings = null;
      this.building_id = null;

      this.busy = this.meetingService.getBuildings(cid, this.authcode).subscribe(response => {
        if (response) {
          if (response.success == -1 || response.success == 0) {
            this.toasterService.pop('error', response.message);
          } else {

            console.log({building: response});

            this.buildings = response;
            if (this.buildings.length === 1) {
              this.building_id = this.buildings[0].id;
              const link = ['/building/' + this.buildings[0].id + ''];
              this.router.navigate(link);
            }
          }
          // // console.log(response);
        }
      });

    }
  }

  populateOpenTimeIntervalArray(p_startTime, p_endTIme) {
    const startTimeMoment = moment('2013-02-08 ' + p_startTime);
    const unixEndTime = moment('2013-02-08 ' + p_endTIme);

    let startTime = startTimeMoment.unix() * 1000;
    const endTIme = unixEndTime.unix() * 1000;

    const timeIntervals = [startTime];
    while (startTime < endTIme) {
      startTime += 30 * 60000;
      timeIntervals.push(startTime);
    }
    // timeIntervals = timeIntervals.map( t => (new Date(t)).toTimeString().replace(/\s[\w\s\+\(\)]+/i, '').replace(/:\d+$/, ''));
    this.openTimeIntervalArray = timeIntervals.map(t => {
      /*let h = (this.convertDateForIos(t)).getHours() + '';
      h = h.length < 2 ? `0${h}` : h;
      let m = (this.convertDateForIos(t)).getMinutes() + '';
      m = m.length < 2 ? `0${m}` : m;*/
      return {
        value: moment.unix(t / 1000).format('HH:mm'), display: moment.unix(t / 1000).format('hh:mm a')
      }; // `${h}:${m}`;
    });
  }

  jump() {
    if (this.skipdate) {
      if (this.skipdate) {
        if (this.skipdate.toString().length > 9) {
          let year = this.skipdate.substring(0, 4);
          if (parseInt(year) > 2010) {
            $('#calendar').fullCalendar('changeView', 'agendaDay');
            $('#calendar').fullCalendar('gotoDate', this.skipdate);
            this.skipdate = '';
            this.getBuildingsMeeting(this.building_id, '');
          }
        }
      }
    }
  }

  login() {
    const link = ['/login'];
    this.router.navigate(link);
  }

  register() {
    this._cookieService.put('reg_city_id', this.id);
    const link = ['/register'];
    this.router.navigate(link);
  }

  eventDelete() {
    console.error('eventDelete() not implemented for city component');
  }

  eventUpdate() {
    console.error('eventUpdate() not implemented for city component');
  }

  signOut() {
    console.error('signOut() not implemented for city component');
  }

}
